// Module
var code = `<template> <div class="step-details col"> <query-builder class="row" prop-value.bind="entity" prop-name="uri" clauses.bind="meta.clauses" view-model.ref="queryBuilder"> </query-builder> </div> </template>`;
// Exports
module.exports = code;